import React from 'react';
import { ScatterChartPanel } from '../../../../../../components/SettingsPanel/subComponents';
import { getSelectedLocationName, removeUrlQueryParam, setUrlQueryParam } from '../../../../../../actions';
import i18n from '../../../../../../i18n';

export default function ATScatterChartPanel({ urlParams, dispatch, state, groupHighlights }) {
	const checkboxes = [
		{
			text: i18n.t('Trend toggle title'),
			onChange: (checked) => {
				if (!checked) {
					dispatch({
						type: 'setUrlQueryParam',
						action: removeUrlQueryParam({ name: 'showClassifications' }),
					});
				} else {
					removeUrlQueryParam({ name: 'range1from' });
					removeUrlQueryParam({ name: 'range1to' });
					dispatch({
						type: 'setUrlQueryParam',
						action: setUrlQueryParam({ name: 'showClassifications', value: true }),
					});
				}
			},
			checked: JSON.parse(urlParams.showClassifications || false),
		},
	];

	return <ScatterChartPanel checkboxes={checkboxes} groupHighlights={groupHighlights} />;
}
